import { Controller } from '@hotwired/stimulus'
import { useTransition, useHotkeys } from 'stimulus-use'
import { useEmitter } from "@/emitter"
import Hammer from 'hammerjs'
import anime from 'animejs'

export default class extends Controller {
    static targets = [
        'container',
        'card',
        'line',
    ]

    static classes = [
        'hidden'
    ]

    connect() {
        useEmitter(this)

        useHotkeys(this, {
            'escape': [this.escHandler]
        })

        useTransition(this, {
            element: this.cardTarget,

            enterActive: "transition-[transform,opacity,background-color] ease-out duration-300",
            enterFrom: "transition-[transform,opacity,background-color] opacity-0 translate-y-3/4",
            enterTo: "transition-[transform,opacity,background-color] opacity-100 translate-0",
            // 
            leaveActive: "transition-[transform,opacity,background-color] ease-in duration-300",
            leaveFrom: "transition-[transform,opacity,background-color] opacity-100 translate-0",
            leaveTo: "transition-[transform,opacity,background-color] opacity-0 translate-y-3/4",
            // 
            hiddenClass: 'hidden',
        })

        this.hammer = new Hammer(this.lineTarget, {
            domEvents: true,
        })

        this.hammer.add(new Hammer.Pan({
            event: 'panv',
            direction: Hammer.DIRECTION_VERTICAL
        }))
    }

    disconnect() {
        this.hammer.destroy()
    }

    escHandler() {
        this.close()
    }

    closeBackground(event) {
        if (!this.cardTarget.contains(event.target) && !this.cardTarget.classList.contains('hidden')) {
            this.close()
        }
    }

    open() {
        this.$emit('scroll:disable')
        this.$emit('backdrop:show')
        this.containerTarget.classList.remove('hidden');
        this.enter()
    }

    async close() {
        await this.leave()
        this.$emit('backdrop:hide')
        this.$emit('scroll:enable')
        this.containerTarget.classList.add('hidden');
    }

 
    cardDrag({ gesture }) {
        const deltaY = gesture.deltaY < 0 ? 0 : gesture.deltaY
            
        this.translateY(deltaY)

        if (gesture.isFinal) {
            const clientHeight = this.cardTarget.clientHeight

            this.translateY()

            if(deltaY > ((clientHeight / 100) * 40)) {
                this.close()
            }
        }
    }

    translateY(value = null) {
        const isNull = value === null

        this.cardTarget.classList.toggle('transition-transform', !isNull)
        this.cardTarget.classList.toggle('ease-linear', !isNull)
        this.cardTarget.classList.toggle('duration-75', !isNull)

        if (isNull) {
            this.cardTarget.style.transform = value

            return
        }

        anime.set(this.cardTarget, {
            translateY: `${value}px`,
        })
    }
}